/* istanbul ignore file */

import { Component } from 'react';
import ArrowUpward from '@mui/icons-material/ArrowUpward';

import scrollMonitor from 'scrollmonitor';

import { styled } from '@classify/react-core-components/styles';
import Button from '@classify/react-core-components/Button';

import browser from '@openclassrooms/utils/browser';

import scrollToElement from '../../services/scrollToElement';

const ButtonContainer = styled('div')({
  zIndex: 1,
  background: '#fff',
  bottom: 0,
  padding: '0.5rem 1rem',
  opacity: 0,
  position: 'sticky',
  textAlign: 'center',
  transition: 'opacity 0.5s ease',

  '& svg': {
    boxShadow: 'none',
  },
});

const withScrollToTopButton =
  ({ getTranslations }) =>
  (WrappedComponent) => {
    class WithScrollToTopButton extends Component {
      static displayName = `WithScrollToTopButton(${
        WrappedComponent.displayName || WrappedComponent.name
      })`;

      constructor(props) {
        super(props);

        this.monitoredElement = null;

        this.state = {
          isButtonShown: false,
        };
      }

      componentDidMount() {
        this.watcher = scrollMonitor.create(this.monitoredElement, -400);

        this.watcher.stateChange((event, watchedElement) => {
          this.setState(() => ({
            isButtonShown: watchedElement.isAboveViewport,
          }));
        });
      }

      render() {
        const { isButtonShown } = this.state;

        return (
          <div
            ref={(e) => {
              this.monitoredElement = e;
            }}
          >
            <WrappedComponent {...this.props} />

            <ButtonContainer style={{ opacity: isButtonShown ? 1 : 0 }}>
              <Button
                variant="tertiary"
                onClick={() => {
                  scrollToElement(browser.document.body, { speed: 0 });
                }}
                endIcon={<ArrowUpward style={{ fontSize: 16 }} />}
              >
                {getTranslations().actionButtonLabel}
              </Button>
            </ButtonContainer>
          </div>
        );
      }
    }

    return WithScrollToTopButton;
  };

export default withScrollToTopButton;
